import { type Entity, type Optional, splitOptionalEntity } from "shelving";
import { ASIDE, wrapText } from "shared/react";
import { isVerifiableType } from "shared/schema";
import { useItem } from "../util/db.js";

/** Only show the children of an element if the creator is a verified creator. */
export function VerifiedCondition({ entity, children, fallback = null }: { entity: Optional<Entity>; children: React.ReactNode; fallback?: React.ReactNode }): React.ReactElement | null {
	const [type, id] = splitOptionalEntity(entity);
	const verified = useItem(type && isVerifiableType(type) ? type : undefined, id)?.value?.verified ?? false;
	return verified ? <>{children}</> : wrapText(fallback, ASIDE);
}
